import React, { useRef } from "react";

/** @typedef {import('../models/RpaOptionModel.js').RpaOptionItem} RpaOptionItem */

/**
 * @typedef {object} RpaLocationParams
 * @property {Array<RpaOptionItem>} rpaOptions - Liste des locations
 * @property {(rpaOption: RpaOptionItem) => void} refreshOption - Fonction de rafraîchissement des options
 */

/**
 * @param {RpaLocationParams} props
 */
export default function RpaOption({ rpaOptions, refreshOption }) {
  /**
   * Gère le click sur la carte d'option en cochant le bouton radio associé
   * @param {any} e - Evenement de click sur la carte d'option
   * @param {RpaOptionItem} rpaOption - Option RPA associée à la carte cliquée
   * @private
   */
  function _onClickOnCard(e, rpaOption) {
    const cardNode = /** @type {HTMLDivElement} */ (e.currentTarget);
    const inputNode = /** @type {HTMLInputElement} */ (cardNode.querySelector('input[type="radio"]'));

    if (inputNode) {
      /** @type {HTMLInputElement} */ inputNode.checked = true;
    }

    refreshOption(rpaOption);
  }

  return (
    <div className="grid grid--has-4-child grid--8-gap grid--has-2-child-mobile no-mobile">
      {rpaOptions.map((rpaOption, index) => (
        <div className="card card-rpaservice" style={{ cursor: "pointer" }} key={index} onClick={e => _onClickOnCard(e, rpaOption)}>
          <div className="card__header">
            <h4>{rpaOption.name}</h4>
          </div>
          <div className="card__image--background" style={{ backgroundImage: `url(${rpaOption.thumbnail ? rpaOption.thumbnail : "/images/NO_THUMBNAIL.webp"})` }}></div>
          <div className="card__description card__description--no-height card__description--center">
            <div dangerouslySetInnerHTML={{ __html: rpaOption.description }}></div>
            {rpaOption.quantifiable ? (
              <>
                <select className="input-control" name="nb_options" aria-label="Nombre d'options">
                  <option value="0">0</option>
                  {Array.from({ length: 10 }, (_, i) => i + 1).map(optionValue => (
                    <option key={optionValue} value={optionValue}>
                      x{optionValue}
                    </option>
                  ))}
                </select>
                <input type="hidden" name="rpaOptionId" value={rpaOption.id} />
              </>
            ) : (
              <input className="input-control" type="radio" name="rpaOptionId" value={rpaOption.id} defaultChecked={index === 0} aria-label="Option RPA" />
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
